import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import i18n from 'i18n-js';

const SearchNotFoundPrompt = (props) => {
  const hiddenCount = Number(props.hiddenCount) || 0;
  const hiddenOrdersText = hiddenCount === 1 ? '1 matching order is' : `${hiddenCount} matching orders are`;
  const message = hiddenCount > 0
    ? `${hiddenOrdersText} hidden by the current filters.`
    : i18n.t('clearFilterPrompt.clearFiltersText');

  return (
    <View pointerEvents="box-none" style={internalStyles.overlay}>
      <View testID='searchNotFoundPrompt' style={internalStyles.promptContainer}>
        <View style={internalStyles.messageContainer}>
          <Text style={internalStyles.messageText}>
              {message}
          </Text>
        </View>
        <TouchableOpacity testID='clearAllfiltersBtn' onPress={props.clearFiltersAndExpandSearch}>
          <Text style={internalStyles.clearFiltersText}>
              {i18n.t('clearFilterPrompt.clearFiltersBtnText')}
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const internalStyles = StyleSheet.create({
  overlay: {
    position: 'absolute',
    top: 120,
    right: 0,
    bottom: 95,
    left: 0,
    zIndex: 2,
    alignItems: 'center',
    justifyContent: 'flex-end',
    backgroundColor: 'transparent',
    paddingBottom: 24,
  },
  promptContainer: {
    alignItems: 'center',
    paddingHorizontal: 24,
    maxWidth: '92%',
  },
  messageContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  messageText: {
    color: 'white',
    fontSize: 23,
    fontFamily: "Poppins_400Regular",
    textAlign: 'center',
  },
  clearFiltersText: {
    color: '#849db8',
    marginTop: 10,
    textAlign: 'center',
    fontSize: 15,
    fontFamily: "Poppins_400Regular",
  }
});

export default SearchNotFoundPrompt;
